import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type FamilyOnboarding = {
  id: string;
  user_id: string;
  email: string;
  who_needs_care: string;
  care_type: string;
  frequency: string;
  urgency: string;
  start_type: string;
  start_date: string | null;
  location: string;
  hourly_budget: number | null;
  created_at: string;
  updated_at: string;
};

const useAdminFamilyOnboarding = (userId: string | undefined) => {
  const queryFn = async (): Promise<FamilyOnboarding | null> => {
    if (!userId) return null;

    console.log('Fetching family onboarding for user:', userId);

    const { data, error } = await supabaseClient
      .from('family_onboarding')
      .select('*')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error fetching family onboarding:', error);
      throw new Error(error.message);
    }

    console.log('Family onboarding data:', data);
    return data;
  };

  return useQuery<FamilyOnboarding | null, Error>({
    queryKey: ['admin-family-onboarding', userId],
    queryFn,
    enabled: !!userId,
  });
};

export default useAdminFamilyOnboarding;
